export default __webpack_public_path__ + "stumbler-fourth.311aff99.mp4";